import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, Accordion, AccordionItem, Collapse } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import ModalImage from "react-modal-image";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import SimpleBar from "simplebar-react";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetCivilBudgetState, getCivilBudget } from "../../../store/civilBudget/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetProductInventoryBranchState, getProductInventoryBranch as onGetProductInventoryBranches, addNewProductInventoryBranch as onAddNewProductInventoryBranch, updateProductInventoryBranch as onUpdateProductInventoryBranch, getProductInventoryBranchLoading } from "../../../store/productInventoryBranch/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading, resetTransferCreateState } from "../../../store/transfer/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { resetClientState, getClient } from "../../../store/client/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Transfer = () => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  const [productInventoryList, setProductInventoryList] = useState([]);
  const [productSelectInventoryList, setProductSelectInventoryList] = useState([]);
  const [productInventoryDetailItem, setProductInventoryDetailItem] = useState([]);
  const [civil_budgetList, setProductionList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");

  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    productInventoryLoading,
    productInventories,
    isProductInventoryCreated,
    isProductInventorySuccess,
    clients,
    clientLoading,
    transfers,
    transferAdded,
    isTransferCreated,
    isTransferSuccess,
    loading,
    error,
    companies,
    companyLoading,
    shipmentMethods,
    shipmentMethodLoading,
    shipmentCarriers,
    shipmentCarrierLoading,
    branches,
    branchLoading,
    productVarians,
    productVarianLoading,
    productInventoryBranches,
    productInventoryBranchAdded,
    isProductInventoryBranchCreated,
    isProductInventoryBranchSuccess,
    productInventoryBranchLoading,
    civilBudgets,
    civilBudgetLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    transferAdded: state.Transfer.transferAdded,
    transfers: state.Transfer.transfers,
    isTransferCreated: state.Transfer.isTransferCreated,
    isTransferSuccess: state.Transfer.isTransferSuccess,
    loading: state.Transfer.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
    shipmentCarrierLoading: state.ShipmentCarrier.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Transfer.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    productInventories: state.ProductInventory.productInventories,
    isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
    isProductInventorySuccess: state.ProductInventory.isProductInventorySuccess,
    productInventoryLoading: state.ProductInventory.loading,
    productInventoryBranchAdded: state.ProductInventoryBranch.productInventoryBranchAdded,
    productInventoryBranches: state.ProductInventoryBranch.productInventoryBranches,
    isProductInventoryBranchCreated: state.ProductInventoryBranch.isProductInventoryBranchCreated,
    isProductInventoryBranchSuccess: state.ProductInventoryBranch.isProductInventoryBranchSuccess,
    productInventoryBranchLoading: state.ProductInventoryBranch.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
  }));

  const [transferList, setTransferList] = useState([]);
  const [transferAllList, setTransferAllList] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [originalFiles, setOriginalFiles] = useState([]);
  const [productList, setProductList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetMaterialList, setCivilBudgetMaterialList] = useState([]);
  const [invDocImg, setInvDocImg] = useState([]);
  const [transferDoc, setTransferDoc] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditOutbound, setIsEditOutbound] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchIdSelected, setBranchIdSelected] = useState(null);

  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [modalMedia, setModalMedia] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const [searchValue, setSearchValue] = useState(false);
  const expanseDataRef = useRef([]);
  const [expense, setExpense] = useState([]);

  const toggleTab = (tab, type) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ companyId: companySelected?.value ?? "", branchId: branchSelected?.value ?? "", date: "all" }));
      handleGetShipmentMethod(companySelected?.value);
      handleGetShipmentCarrier(companySelected?.value);
      handleGetCivilBudget(companySelected?.value);
      handleGetProductVariant(companySelected?.value);
      setBranchIdSelected(branchSelected?.value);
      dispatch(onGetProductInventoryBranches({ branchId: branchSelected?.value, type: "inbound-product" }));
    }
  }, [branchSelected, companySelected]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetCivilBudget = (companyId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId }));
  };

  const handleGetBranch = useCallback(
    (id) => {
      dispatch(resetBranchState());
      dispatch(getBranch({ companyId: id, status: 2 }));
    },
    [dispatch]
  );

  const handleGetShipmentCarrier = (companyId) => {
    dispatch(resetShipmentCarrierState());
    dispatch(getShipmentCarrier({ companyId: companyId, status: 2, type: "Transfer" }));
  };

  const handleGetShipmentMethod = (companyId) => {
    dispatch(resetShipmentMethodState());
    dispatch(getShipmentMethod({ companyId: companyId, status: 2, type: "Transfer" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      let productVarianData = [];
      let blockData = [];
      let opt = [];
      let block = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product;
        const blck = varian.product_block ? varian.product_block.id : "";
        const blck_name = varian.product_block ? varian.product_block.name : "";
        const name = blck_name + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const brandId = item.brandId;
        const productId = item.productId;
        const branch = varian.branchId ? varian.branchId : "";

        if (item.typeId === 1) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, barcode: barcode, sku: sku, value: id, brandId: brandId, productId: productId });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });
          }
        }
      });
      let option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);

      let option_block = { options: block };
      blockData.push(option_block);
      setBlockList(blockData);
    }
  }, [productVarians, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(productInventoryBranches)) {
      let materialVarianData = [];
      let opt_material = [];
      productInventoryBranches.forEach((item, key) => {
        const varian = item.inv_branch_varian;
        const product = item.inv_branch_product;
        const allocated = isNaN(parseFloat(item.allocated)) ? 0 : parseFloat(item.allocated);
        const stocks = isNaN(parseFloat(item.stocks)) ? 0 : parseFloat(item.stocks);
        const onhand = stocks - allocated;
        opt_material.push({ label: product.name, stock: item.stocks, allocated: allocated, onhand: onhand, uom: product?.product_uom?.name, name: varian.name, barcode: varian.barcode, sku: varian.sku, value: varian.id, brandId: varian.brandId, productId: varian.productId, productInventoryBranchId: item.id });

      });
      let option_material = { options: opt_material.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      materialVarianData.push(option_material);
      setMaterialList(materialVarianData);
    }
  }, [productInventoryBranches]);

  useEffect(() => {
    setProductInventoryList(productInventoryBranches);
  }, [productInventoryBranches]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      let arr = [];
      let arrAllMaterial = [];

      transfers.filter(f => f.statusId === 5).forEach(data => {
        (data.transfer_detail || []).forEach(td => {
          let material = arrAllMaterial.findIndex((d) => d.productId === td.productId);
          if (material !== -1) {
            arrAllMaterial[material].quantity = parseFloat(arrAllMaterial[material].quantity) + parseFloat(td.quantity);
            arrAllMaterial[material].data = [...arrAllMaterial[material].data, data];
          }
          else {
            arrAllMaterial.push({
              productId: td.productId,
              name: td?.transfer_detail_product?.name ?? "",
              uom: td?.transfer_detail_product?.product_uom?.name ?? "",
              cvl_account: td.transfer_cvl_account?.name ?? "",
              cvl_account_job: td.transfer_cvl_budget_job?.cvld_account?.name ?? "",
              type: td?.transfer_cvl_budget?.type,
              quantity: parseFloat(td.quantity),
              quantity_need: parseFloat(td.quantity_need),
              data: [data],
            });
          }

        });

        let blockId = null;
        let blockName = ' NON BLOK';
        if (data.blockId) {
          blockName = data?.transfer_block?.name;
          blockId = data.blockId;
        }

        let block = arr.find((d) => d.name === blockName);
        if (block) {
          let arrMaterial = block.material;
          (data.transfer_detail || []).forEach(td => {
            let cvl_account = td.transfer_cvl_account?.name ?? "";
            let cvl_account_job = td.transfer_cvl_budget_job?.cvld_account?.name ?? "";
            let material = arrMaterial.findIndex((d) => d.productId === td.productId && d.cvl_account === cvl_account && d.cvl_account_job === cvl_account_job);
            if (material !== -1) {
              arrMaterial[material].quantity = parseFloat(arrMaterial[material].quantity) + parseFloat(td.quantity);
              arrMaterial[material].data = [...arrMaterial[material].data, data];
            }
            else {
              arrMaterial.push({
                productId: td.productId,
                name: td?.transfer_detail_product?.name ?? "",
                uom: td?.transfer_detail_product?.product_uom?.name ?? "",
                cvl_account: td.transfer_cvl_account?.name ?? "",
                cvl_account_job: td.transfer_cvl_budget_job?.cvld_account?.name ?? "",
                type: td?.transfer_cvl_budget?.type,
                quantity: parseFloat(td.quantity),
                quantity_need: parseFloat(td.quantity_need),
                data: [data],
              });
            }

          });
          //block.data.push(data);
        }
        else {
          let arrMaterial = [];
          (data.transfer_detail || []).forEach(td => {
            let cvl_account = td.transfer_cvl_account?.name ?? "";
            let cvl_account_job = td.transfer_cvl_budget_job?.cvld_account?.name ?? "";
            let material = arrMaterial.findIndex((d) => d.productId === td.productId && d.cvl_account === cvl_account && d.cvl_account_job === cvl_account_job);
            if (material !== -1) {
              arrMaterial[material].quantity = parseFloat(arrMaterial[material].quantity) + parseFloat(td.quantity);
              arrMaterial[material].data = [...arrMaterial[material].data, data];
            }
            else {
              arrMaterial.push({
                productId: td.productId,
                name: td?.transfer_detail_product?.name ?? "",
                uom: td?.transfer_detail_product?.product_uom?.name ?? "",
                cvl_account: td.transfer_cvl_account?.name ?? "",
                cvl_account_job: td.transfer_cvl_budget_job?.cvld_account?.name ?? "",
                type: td?.transfer_cvl_budget?.type,
                quantity: parseFloat(td.quantity),
                quantity_need: parseFloat(td.quantity_need),
                data: [data],
              });
            }

          });
          arr.push({
            name: blockName,
            material: arrMaterial,
          })
        }
      });

      setTransferAllList([{
        name: "ALL",
        material: arrAllMaterial,
      }]);
      setTransferList(arr);
    }
    else {
      setTransferList([]);
      setTransferAllList([]);
    }
  }, [transfers]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal Keluar",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_from",
        label: "Pengirim",
        isSelected: true,
        data: [],
      },
      {
        id: "transfer_to",
        label: "Penerima",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Sistem",
        isSelected: true,
        data: [],
      },
      {
        id: "budget",
        label: "Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "pekerjaan",
        label: "Pekerjaan",
        isSelected: true,
        data: [],
      },
      {
        id: "block",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "material",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "volume",
        label: "Volume",
        isSelected: true,
        data: [],
      },
      {
        id: "uom",
        label: "Satuan",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (transferList.length > 0) {
      transferList.forEach((transfer) => {
        if (transfer.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(transfer.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          if (doc) doc.data.push(handleValidDate(transfer.transactionat));

          doc = dataDoc.find((d) => d.id === "transfer_from");
          if (doc) doc.data.push(transfer?.transfer_from?.name);

          doc = dataDoc.find((d) => d.id === "transfer_to");
          if (doc) doc.data.push(transfer?.transfer_to?.name || transfer?.type);

          doc = dataDoc.find((d) => d.id === "block");
          if (doc) doc.data.push(transfer?.transfer_block?.name);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(transfer?.description);

          transfer.transfer_detail.forEach((item, idx) => {
            if (!first) {
              doc = dataDoc.find((d) => d.id === "transfer_from");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transfer_to");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transaction_no");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transactionat");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "block");
              if (doc) doc.data.push(transfer?.transfer_block?.name);
            }
            first = false;

            doc = dataDoc.find((d) => d.id === "budget");
            if (doc) doc.data.push(item?.transfer_cvl_account?.name);

            doc = dataDoc.find((d) => d.id === "pekerjaan");
            if (doc) doc.data.push(item?.transfer_cvl_account_job?.name);

            doc = dataDoc.find((d) => d.id === "material");
            if (doc) doc.data.push(item.name);

            doc = dataDoc.find((d) => d.id === "volume");
            if (doc) doc.data.push(parseFloat(item.quantity));

            doc = dataDoc.find((d) => d.id === "uom");
            if (doc) doc.data.push(item?.transfer_detail_product?.product_uom?.name);

          });
        }
      });
    }
    setTransferDoc(dataDoc);
  }, [transferList]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      let civilBudgetMaterialData = [];
      let optMaterial = [];
      let civilBudgetData = [];
      let opt = [];
      civilBudgets.forEach((it, idx) => {
        if (branchIdSelected === it.branchId) {
          it.cvl_detail.forEach((item, key) => {
            const name = item.cvld_account ? it.type + " - " + item?.cvld_account?.name : "";
            const id = item.cvld_account ? item.cvld_account.id : "";
            let obj = { label: name, value: id, cvl_account_job: item?.cvld_account?.name, cvl_account: name, name: item?.cvld_account?.name, type: it.type, civilBudgetDetailId: item.id, civilBudgetId: it.id, civilAccountId: id, cvlBudgetDetailId: item.id, cvlBudgetId: it.id, cvlAccountId: id, material: item.cvld_material };
            if (it.type === "PROGRESS BANGUNAN") {
              obj = { label: item?.cvld_account?.name, value: id, cvl_account_job: item?.cvld_account?.name, cvl_account: name, name: item?.cvld_account?.name, type: it.type, civilBudgetDetailId: item.id, civilBudgetId: it.id, civilAccountId: id, cvlBudgetDetailId: item.id, cvlBudgetId: it.id, cvlAccountId: id, material: item.cvld_material };
              opt.push(obj);
            } else {
              if (item.cvld_material && item.cvld_material.length > 0) {
                optMaterial.push(obj);
              }
            }
          });
        }
      });
      let option = { options: opt };
      let option_material = { options: optMaterial };
      civilBudgetData.push(option);
      civilBudgetMaterialData.push(option_material);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetMaterialList(civilBudgetMaterialData);
    }
    else {
      setCivilBudgetList([]);
      setCivilBudgetMaterialList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  useEffect(() => {
    let data = [];
    let opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      let obj = { label: name, value: id };
      opt.push(obj);
    });
    let option = { options: opt };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      let data = [];
      let opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      let data = [];
      let opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      let data = [];
      let opt = [];
      shipmentCarriers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      let data = [];
      let opt = [];
      shipmentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        let obj = { label: name, value: id };
        opt.push(obj);
      });
      let option = { options: opt };
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransfer(null);
      setOriginalFiles([]);
      setInvDocImg([]);
      setTransferDetailItem([]);
    } else {
      setProductInventoryList([]);
      setModal(true);
    }
  }, [modal]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setOriginalFiles([]);
      setTransferDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    let status = statusTransfer.value ? statusTransfer.value : "";
    const param = {
      startat: startat,
      endat: endat,
      status: status,
      type: "",
      branchId: branchSelected.value,
    };
    dispatch(onGetTransfers(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setTransferList([]);
    dispatch(resetTransferState());
    dispatch(onGetTransfers({ companyId: companySelected?.value ?? "", branchId: branchSelected.value ?? "", date: "all" }));
  };

  function currencyFormat(num) {
    return parseFloat(Math.round(num)).toLocaleString(["ban", "id"]);
  }

  document.title = "Transfer Request | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Pengeluaran Material" loading={loading}>
          <div className="flex-shrink-0">
            {/* <ExportDoc data={transferDoc} /> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "all" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("all");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    {(transferList || []).map((element, index) => {
                      return <NavItem key={index}>
                        <NavLink
                          className={classnames({ active: activeTab === element.name }, "fw-semibold")}
                          onClick={() => {
                            toggleTab(element.name);
                          }}
                          href="#"
                        >{element.name}
                        </NavLink>
                      </NavItem>
                    })}
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              placeholder={`Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    {activeTab !== "all" && <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="bg-white">
                          <th scope="col" className="text-start bg-light text-muted">MATERIAL</th>
                          <th scope="col" className="text-end bg-light text-muted">JUMLAH</th>
                          <th scope="col" className="text-start bg-light text-muted"></th>
                          <th scope="col" className="text-start bg-light text-muted">RAB</th>
                          <th scope="col" className="text-start bg-light text-muted">URAIAN RAB</th>
                          <th scope="col" className="text-start fs-14 bg-light text-muted"> URAIAN PEKERJAAN</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(transferList || []).filter(f => f.name === activeTab).map((element, index) => {
                          return (
                            <Fragment key={index}>
                              {(element.material || [])
                                .sort((a, b) => (a.sort_order ?? "").toString().localeCompare((b.sort_order ?? "").toString(), undefined, { numeric: true, sensitivity: 'base' }) || (a.cvl_account_job ?? "").toString().localeCompare((b.cvl_account_job ?? "").toString(), undefined, { numeric: true, sensitivity: 'base' }))
                                .map((el, idx) => {

                                  return (<tr key={idx} className="pb-4 cursor-pointer" onClick={() => {
                                    expanseDataRef.current = el.data;
                                    setExpense(el.data);
                                    toggleDetail();
                                  }}>
                                    <td className="text-start fw-semibold pe-2 fs-14">{el.name}</td>
                                    <td className="text-end fw-semibold pe-2 fs-14">{el.quantity.toFixed(2)}</td>
                                    <td className="text-start pe-2 fs-14">{el.uom}</td>
                                    <td className="text-start pe-2 fs-14">{el.type}</td>
                                    <td className="text-start pe-2 fs-14">{el.cvl_account}</td>
                                    <th className="text-start fs-14">{el.cvl_account_job}</th>
                                  </tr>)
                                })
                              }
                            </Fragment>)

                        })}
                      </tbody>
                    </Table>}

                    {activeTab === "all" && <Table className="table-border text-center table-hover table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="bg-white">
                          <th scope="col" className="text-start bg-light text-muted">MATERIAL</th>
                          <th scope="col" className="text-end bg-light text-muted">JUMLAH</th>
                          <th scope="col" className="text-start bg-light text-muted"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(transferAllList || []).map((element, index) => {
                          return (
                            <Fragment key={index}>
                              {(element.material || [])
                                .sort((a, b) => (a.sort_order ?? "").toString().localeCompare((b.sort_order ?? "").toString(), undefined, { numeric: true, sensitivity: 'base' }) || (a.cvl_account_job ?? "").toString().localeCompare((b.cvl_account_job ?? "").toString(), undefined, { numeric: true, sensitivity: 'base' }))
                                .map((el, idx) => {

                                  return (<tr key={idx} className="pb-4 cursor-pointer" onClick={() => {
                                    expanseDataRef.current = el.data;
                                    setExpense(el.data);
                                    toggleDetail();
                                  }}>
                                    <td className="text-start fw-semibold pe-2 fs-14">{el.name}</td>
                                    <td className="text-end fw-semibold pe-2 fs-14">{el.quantity.toFixed(2)}</td>
                                    <td className="text-start pe-2 fs-14">{el.uom}</td>
                                  </tr>)
                                })
                              }
                            </Fragment>)

                        })}
                      </tbody>
                    </Table>}

                  </div>

                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Transfer Persediaan" : "Tambah Transfer Persediaan"}
                  </ModalHeader>

                  <ModalBody>

                  </ModalBody>

                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    DETAIL PENGELUARAN MATERIAL
                  </ModalHeader>
                  <ModalBody>

                    <div>
                      <CardBody className="border-top border-top-dashed">
                        <SimpleBar style={{ height: "520px" }}>
                          <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                            <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                              <tr className="bg-soft-info">
                                <td style={{ width: "20px" }}>
                                  <input
                                    type="checkbox"
                                    className="checkboxDetailAll me-2 form-check-input"
                                    checked={expense.every((item) => item.isChecked)}
                                    onChange={() => {
                                      const allChecked = expense.every((item) => item.isChecked);
                                      const updatedData = expense.map((item) => {
                                        return {
                                          ...item,
                                          isChecked: !allChecked,
                                        };
                                      });
                                      setExpense(updatedData);
                                    }}
                                  />
                                </td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Tanggal
                                </td>
                                <td className="text-center" style={{ width: "120px" }}>
                                  No Transaksi
                                </td>
                                <td className="text-center">PIC</td>
                                <td className="text-center" style={{ width: "100px" }}>
                                  Jenis Pengeluaran
                                </td>
                                <td className="text-start">Keterangan</td>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(expense || [])
                                .map((o, i) => {
                                  return <Fragment key={i}>
                                    <tr className="product bg-light">
                                      <td className="product-id">
                                        <input
                                          type="checkbox"
                                          className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                          checked={o.isChecked}
                                          onChange={() => {
                                            const updatedData = expense.map((d) => {
                                              return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                            });

                                            setExpense(updatedData);
                                          }}
                                        />
                                      </td>
                                      <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                      <td className="text-center">{o?.code}</td>
                                      <td className={"text-center fw-semibold"}>{o?.transfer_approvedby?.name}</td>
                                      <td className="text-center">{o?.type}</td>
                                      <td className="text-start">{o.description}</td>
                                    </tr>
                                    {(o.transfer_detail || []).map((oo, ii) => {
                                      return (
                                        <tr key={ii} className="product">
                                          <td className="product-id fs-11" colSpan={2}> </td>
                                          <td className="text-start text-muted fs-11" colSpan={3}>
                                            {oo?.transfer_detail_product?.name},  ( {currencyFormat(parseFloat(oo.quantity ?? 0))} {oo?.transfer_detail_product?.product_uom?.name} )
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </Fragment>
                                })}
                              {expense.length === 0 && (
                                <tr>
                                  <td colSpan="11" className="p-3 text-center">
                                    Belum ada data
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </CardBody>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        Tutup
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={transfer} />
      </Container>
    </div>
  );
};

export default Transfer;
